import React, { useEffect, useState, useRef } from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import XLSX from "xlsx";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import {
  CardContent,
  Grid,
  InputAdornment,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
  Select,
  FormControl,
  Button,
  Paper,
  Collapse,
  Box,
  Autocomplete,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogContentText,
  Alert,
  DialogActions,
  Divider,
  MenuItem,
} from "@material-ui/core";
import Chip from "../../ui-component/extended/Chip";
// project imports
import MainCard from "../../ui-component/cards/MainCard";

import IconButton from "@material-ui/core/IconButton";
import FirstPageIcon from "@material-ui/icons/FirstPage";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import LastPageIcon from "@material-ui/icons/LastPage";
import axios from "axios";
import ApiInstance from "../../Services/ApiInstance";
import moment from "moment";
import Ordershippopup from "../Vendor/Ordershippopup";
import AlertModal from "./AlertModal";
import { LoadingButton } from "@material-ui/lab";
import { numericCommaSeparation } from "../../ui-component/NumericSeperation";
import { getDecryptDataFromLocal } from "../../utils/encrypt";
import { InputLabel } from "@mui/material";
import EditAddressInOrderModal from "./EditAddressInOrderModal";
import OrderCancelRemarkModal from "./OrderCancelRemarkModal";
// import CancelApiInstance, {
//   cancelAllRequests,
// } from "../../Services/CancelApiInstance";
let appVersion = 692;
const SheetJSFT = [
  "xlsx",
  "xlsb",
  "xlsm",
  "xls",
  "xml",
  "csv",
  "txt",
  "ods",
  "fods",
  "uos",
  "sylk",
  "dif",
  "dbf",
  "prn",
  "qpw",
  "123",
  "wb*",
  "wq*",
  "html",
  "htm",
]
  .map(function (x) {
    return "." + x;
  })
  .join(",");
const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    overflow: "hidden",
  },
  container: {
    maxHeight: 440,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
    maxWidth: 300,
  },
  chips: {
    display: "flex",
    flexWrap: "wrap",
  },
  chip: {
    margin: 2,
  },
  noLabel: {
    marginTop: theme.spacing(3),
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
}));

const tyoeOfObj = {
  1: "Bulk Order",
  2: "GT order",
  3: "E-commerce",
};

const getQueryParams = (key) => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(key);
};

//-----------------------|| TABLE - STICKY HEADER ||-----------------------//

export default function BulkOrderList() {
  const classes = useStyles();
  let paramsData = getQueryParams("orderId");
  const [page, setPage] = React.useState(0);
  const [date, setDate] = useState({
    startDate: moment().clone().startOf("month").format("YYYY-MM-DD"),
    endDate: new Date().toISOString().slice(0, 10),
  });
  const [loading, setLoading] = useState(false);
  const accessButtonForCancelOrder = [
    "9719836187",
    "8826193896",
    "8800970879",
    "9891774071",
    "7052950504",
    "9599412543",
    "8130902064"
  ];
  let crmPhoneNumner = getDecryptDataFromLocal("phoneNumber");
  const onlyReadAccess = ['9716226377']
  const [rowsPerPage, setRowsPerPage] = React.useState(25);
  const [orderdata, setOrderData] = useState([]);
  const [search, setSearch] = React.useState("");
  const [pageLoad, togglePageLoad] = useState(false);
  const [totalpage, setTotalPage] = useState(0);
  const [disableBtn, setDisableBtn] = useState(false);
  const [selectedAgents, setSelectedAgents] = useState(null);
  const [bulkOrderFromRocket, setBulkOrderFromRocket] = useState(false);
  const [cnDiscount, setCnDiscount] = useState("");
  const [isRemarkModalOpen, setIsRemarkModalOpen] = useState(false)
  const [selectOrderId, setSelectOrderId] = useState(null)
  const [parentBulkNumericOrderId, setParentBulkNumericOrderId] = useState(
    paramsData || ""
  );

  const [limitOfProducts, setLimitOfProducts] = useState(20);
  const [openTableIndex, setOpenTable] = useState({
    index: null,
    isOpen: false,
  });
  const [cnDiscountModal, setCnDiscountModal] = useState({
    orderId: "",
    modal: false,
  });
  const [shippingModeModal, setShippingModeModal] = useState(false);
  const [orderIdClick, setOrderIdClick] = useState("");
  const [loadingOfShiprocketOrder, setLoadingOfPlaceOrder] = useState(false);
  const [openShipmentPopup, setShipmentPopup] = useState({
    open: false,
    orderId: null,
    orderName: "",
    type: "",
    isrocketOrPorter: false,
    organizations: null,
  });

  const [shipShopyModal, setShipShopyModal] = useState({
    open: false,
    orderId: null,
    couriers: [],
    loading: false,
    selectedCourierId: "",
    weight: "",
  });

  const [ewayBillModal, setEwayBillModal] = useState({
    orderId: "",
    modal: false,
  });
  const [ewayBillNumber, setEwayBillNumber] = useState("");
  const [isZohoInvoce, setIsZohoInvoice] = useState(null);
  const [orderTable, setOrderTable] = useState([1]);
  const [numOrder, setNumOfOrders] = useState([]);
  const [createPoDisable, setCreatePoDisable] = useState(false);
  const [openAddressModal, setOpenAddressModal] = useState(false);
  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const [selectedAddress, setSelectAddress] = useState({});
  // const controllerRef = useRef(null); // Store AbortController reference

  // const testCancelRequest = async () => {
  //   // setLoading(true);

  //   try {
  //     const response = await CancelApiInstance.post("/testing/data"); // Ensure proper await
  //     console.log("✅ Response received:", response.data);
  //   } catch (error) {
  //     if (axios.isCancel(error)) {
  //       console.log("❌ Request was canceled.");
  //     } else {
  //       console.error("⛔ API Error:", error);
  //     }
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const dataLoad = async (p = page, row = rowsPerPage) => {
    setLoading(true);
    axios
      .post(process.env.REACT_APP_PATH_BULK + "/sales/getBulkOrders", {
        // agentId: selectedAgents?._id||null,
        status: 1,
        page: p + 1,
        pageLimit: row,
        startDate: date.startDate,
        endDate: date.endDate,
        parentBulkNumericOrderId: +parentBulkNumericOrderId,
      })
      .then((res) => {
        if (res.data.success) {
          setOrderData(res.data.data[0].data || []);
          togglePageLoad(true);
          setTotalPage(res.data.data[0]?.metadata[0]?.totalDocuments);
          setLoading(false);
          setDisableBtn(false);
        } else {
          alert(res.data?.message || "Someting went wrong");
          setLoading(false);
        }
      })
      .catch((error) => {
        console.log("error of get data", error);
        setLoading(false);
      });
  };

  const updateEwayBillNumber = () => {
    axios
      .post(process.env.REACT_APP_PATH_BULK + "/products/updateEwayBillNumber", {
        orderId: ewayBillModal.orderId,
        ewayBillNumber: ewayBillNumber,
      })
      .then((res) => {
        console.log("res of updateEway bill", res.data);
        if (res.data.success) {
          alert("Update successfully");
          dataLoad(page, rowsPerPage);
          setEwayBillModal({
            modal: false,
            orderId: "",
          });
        } else {
          alert(res.data?.message || "something went wrong");
        }
      })
      .catch((error) => {
        console.log("error of eway bill", error);
        alert("something went wrong");
      });
  };
  const CancelChildOrder = ({ reason, remark }) => {
    axios
      .post(
        process.env.REACT_APP_PATH_BULK + "/products/cancelBulkInvoiceOrders",
        {
          orderId: selectOrderId,
          reason,
          remarks: remark
        }
      )
      .then((res) => {
        if (res.data.success) {
          alert(res.data?.message || "Successfully cancel order");
          setIsRemarkModalOpen(false)
          setSelectOrderId(null)
        } else {
          alert(res.data?.message || "Someting went wrong");
          setIsRemarkModalOpen(false)
          setSelectOrderId(null)
        }
      })
      .catch((error) => {
        console.log("error", error);
        alert("Someting went wrong");
      });
  };

  const updateCnDiscount = () => {
    axios
      .post(
        process.env.REACT_APP_PATH_BULK + "/products/updateCnDiscountPercentage",
        {
          orderId: cnDiscountModal.orderId,
          cnDiscountPercentage: cnDiscount,
        }
      )
      .then((res) => {
        console.log("res of updateCnDiscountPercentage bill", res.data);
        if (res.data.success) {
          alert("Update successfully");
          dataLoad(page, rowsPerPage);
          setCnDiscountModal({
            modal: false,
            orderId: "",
          });
        } else {
          alert(res.data?.message || "something went wrong");
        }
      })
      .catch((error) => {
        console.log("error of updateCnDiscountPercentage ", error);
        alert("something went wrong");
      });
  };

  const createOrder = (orderId, index, emergent) => {
    if (!emergent) {
      alert("Please Select Organization");
      return;
    }
    setDisableBtn(true);
    const dataObj = {
      orderId: orderId,
      emergentOrFlorida: emergent,
    };
    axios({
      method: "POST",
      url: `${process.env.REACT_APP_PATH_BULK}/products/createBulkSalesOrderOnUc`,
      data: dataObj,
    })
      .then((res) => {
        if (res.data.success) {
          setDisableBtn(false);
          dataLoad(0, 25);
        } else {
          alert(res.data.message);
          setDisableBtn(false);
          // UC already has this code — reload so the row flips to "Cancel On UC & Change Order Id"
          if (/DUPLICATE_SALE_ORDER/i.test(res.data.message || "")) dataLoad();
        }
      })
      .catch((err) => {
        alert("Something went wrong");
        setDisableBtn(false);
      });
  };

  const cancelUcAndChangeOrderId = (order) => {
    if (
      !window.confirm(
        `Order ${order?.numericOrderId} already exists on Unicommerce.\n\nThis will CANCEL it on Unicommerce (if not already cancelled) and give this order a new Order Id. Continue?`
      )
    )
      return;
    setDisableBtn(true);
    axios({
      method: "POST",
      url: `${process.env.REACT_APP_PATH_BULK}/products/cancelUcOrderAndChangeBulkOrderId`,
      data: { orderId: order?._id },
    })
      .then((res) => {
        alert(res.data.message);
        setDisableBtn(false);
        if (res.data.success) dataLoad();
      })
      .catch(() => {
        alert("Something went wrong");
        setDisableBtn(false);
      });
  };

  const addAddressInOrder = async (address, orderId) => {
    console.log({
      address: address,
      addressId: address?._id,
      orderId: orderId,
    });
    try {
      let res = await axios.post(
        process.env.REACT_APP_PATH_BULK + "/sales/addAddressToCrmOrder",
        {
          address: address,
          addressId: address?._id,
          orderId: orderId,
        }
      );
      console.log("res of add address", res.data);
      if (res.data.success) {
        return true;
      } else return false;
    } catch (error) {
      console.log("error of add address", error);
      return false;
    }
  };

  const captureProductOrder = (
    orderId,
    paymentMethod,
    agentId,
    bulkOrderId
  ) => {
    axios
      .post(process.env.REACT_APP_PATH_BULK + "/sales/captureCrmOrder", {
        orderId: orderId,
        paymentMethod: paymentMethod,
        agentId: agentId,
        crmBulkOrderId: bulkOrderId,
      })
      .then((res) => {
        console.log("res of capture order", res.data);
        if (res.data.success) {
          alert(res.data.message);
          window.location.reload();
          setLoadingOfPlaceOrder(false);
        } else {
          alert(res.data.message);
          setLoadingOfPlaceOrder(false);
        }
      })
      .catch((error) => {
        console.log("error", error);
        setLoadingOfPlaceOrder(false);
        alert("Something went wrong");
      });
  };

  const createOrderOnShiprocket = (
    products,
    sellerIdFromClone,
    agentId,
    paymentMethod,
    address,
    bulkOrderId,
    oldDate
  ) => {
    let confirm = window.confirm(
      "Are you sure you want to ship this order through Shiprocket?"
    );
    if (!confirm) {
      return;
    }

    setLoadingOfPlaceOrder(true);
    let reqObj = {
      products: products,
      paymentMethod: Number(paymentMethod),
      bookingSource: 2,
      rewardProducts: undefined,
      freeProducts: [],
      sellerId: sellerIdFromClone,
      appVersion,
      isBulkOrder: true,
      agentId: agentId,
      isCrmBulkToCreateOrder: true,
      crmBulkOrderDate: oldDate,
      bulkOrderId,
    };
    console.log("reqObj", reqObj);

    axios({
      method: "POST",
      url: `${process.env.REACT_APP_PATH_BULK}/sales/createCrmOrder`,
      data: reqObj,
    })
      .then(async (res) => {
        if (res.data.success) {
          console.log("res of create order", res.data);
          if (res?.data?.message?.length > 0) {
            alert(res?.data?.message);
            setLoadingOfPlaceOrder(false);
          } else {
            let addressRes = await addAddressInOrder(address, res.data.orderId);
            console.log("addressRes", addressRes);
            if (addressRes) {
              captureProductOrder(
                res.data.orderId,
                paymentMethod,
                agentId,
                bulkOrderId
              );
            }
          }
        } else {
          alert(res.data.message);
          setLoadingOfPlaceOrder(false);
        }
      })
      .catch((err) => {
        alert("Something went wrong");
        setLoadingOfPlaceOrder(false);
      });
  };

  useEffect(() => {
    if(paramsData){
      dataLoad(page, rowsPerPage);
    }
    // return () => {
    //   cancelAllRequests();
    // };
  }, [paramsData]);

  const createPoOnZoho = (orderId, org) => {
    if (!org) {
      alert("Please Select Organization");
      return;
    }
    setCreatePoDisable(true);
    ApiInstance.post("/products/createPurchaseOrderAtZoho", {
      orderId: orderId,
      emergentOrFlorida: org,
    })
      .then((res) => {
        if (res.data.success) {
          alert(res.data.message || "Success");
          dataLoad();
        } else {
          alert(res.data.message || "Someting went wrong");
          setCreatePoDisable(false);
        }
      })
      .catch((error) => {
        alert("Someting went wrong");
        setCreatePoDisable(false);
      });
  };

  const submitShipShopyCourier = () => {
    if (!shipShopyModal.selectedCourierId) {
      alert("Please select a courier");
      return;
    }
    setShipShopyModal({ ...shipShopyModal, loading: true });
    let payload = {
      orderId: shipShopyModal.orderId,
      courierId: shipShopyModal.selectedCourierId,
      assignCourier: true,
    };

    axios
      .post(
        process.env.REACT_APP_PATH_BULK +
          "/products/updateAwbNumberInShipShopyOrders",
        payload
      )
      .then((res) => {
        if (res.data.success) {
          alert(res.data.message || "Updated Successfully");
          setShipShopyModal({ open: false, orderId: null, couriers: [], loading: false, selectedCourierId: "", weight: "" });
          dataLoad();
          window.location.reload();
        } else {
          alert(res.data.message || "Something went wrong");
          setShipShopyModal({ ...shipShopyModal, loading: false });
        }
      })
      .catch((error) => {
        console.log("error", error);
        alert("Something went wrong");
        setShipShopyModal({ ...shipShopyModal, loading: false });
      });
  };

  const handleShipShopyAction = (order) => {
    if (order?.shipShopyResponse?.orderType === "SPS" && order?.shipShopyResponse?.courierAssigned === false) {
      setShipShopyModal({ ...shipShopyModal, open: true, orderId: order?._id, weight: order?.weight || "", loading: true, couriers: [] });

      axios.post(process.env.REACT_APP_PATH_BULK + "/products/getAvailableCouriers", {
        orderId: order?._id
      }).then((res) => {
        if (res.data.result === "1" || res.data.success) {
          setShipShopyModal({ open: true, orderId: order?._id, weight: order?.weight || "", couriers: res.data.data, loading: false, selectedCourierId: "" });
        } else {
          alert(res.data.message || "Failed to fetch couriers");
          setShipShopyModal({ open: false, orderId: null, couriers: [], loading: false, selectedCourierId: "", weight: "" });
        }
      }).catch(err => {
        console.log("error", err);
        alert("Something went wrong");
        setShipShopyModal({ open: false, orderId: null, couriers: [], loading: false, selectedCourierId: "", weight: "" });
      });
      return;
    }

    setDisableBtn(true);
    let payload = {
      orderId: order?._id,
    };

    if (order?.shipShopyResponse?.courierAssigned === false) {
      payload.assignCourier = true;
    }

    axios
      .post(
        process.env.REACT_APP_PATH_BULK +
          "/products/updateAwbNumberInShipShopyOrders",
        payload
      )
      .then((res) => {
        if (res.data.success) {
          alert(res.data.message || "Updated Successfully");
          dataLoad();
          window.location.reload();
        } else {
          alert(res.data.message || "Something went wrong");
          setDisableBtn(false);
        }
      })
      .catch((error) => {
        console.log("error", error);
        alert("Something went wrong");
        setDisableBtn(false);
      });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    dataLoad(newPage, rowsPerPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    dataLoad(0, event.target.value);
    setPage(0);
  };

  // if (!pageLoad) {
  //   return (
  //     <Paper align="center">
  //       <img
  //         alt="Example Alt"
  //         style={{ width: "200px", height: "130px" }}
  //         src="https://upload.wikimedia.org/wikipedia/commons/b/b1/Loading_icon.gif"
  //         align="center"
  //       />
  //     </Paper>
  //   );
  // }

  const handelShippingMode = (orderId, createInvoice, order) => {
    setDisableBtn(true);
    if (createInvoice) {
      if (!['9599412543', '8178277221', '7052950504', "9719836187","8130902064"].includes(crmPhoneNumner)) {
        alert(`You don't have access to create invoice on zoho!`)
        setDisableBtn(false)
        return
      }
      // let url = bulkOrder?`${process.env.REACT_APP_PATH_BULK}/products/shipBulkOrderFromUc` : openShipmentPopup?.type == 'unicommerce' ? `${process.env.REACT_APP_PATH_BULK}/products/shipOrderFromUc` : `${process.env.REACT_APP_PATH_BULK}/products/shipFloridaOrder`
      let url = null;
      url = `${process.env.REACT_APP_PATH_BULK}/products/shipBulkOrderFromRocketBox`;

      const dataObj = {
        orderId: order?._id,
        isrocketOrPorter: true,
        packagingUnitDetails: [],
      };
      axios({
        method: "POST",
        url: url,
        data: dataObj,
      })
        .then((res) => {
          if (res.data.success) {
            setDisableBtn(false);
            res?.data?.data?.labelUrl &&
              window.open(res?.data?.data?.labelUrl, "_blank");
            alert("orders shipped successful");
            dataLoad()
          } else {
            let error = res.data.message || "";
            alert(error);
            setDisableBtn(false);
          }
        })
        .catch((err) => {
          let error = err?.response?.data?.message || "";
          if (openShipmentPopup?.type == "unicommerce") {
            alert(error);
            dataLoad()
          } else {
            if (error == "") {
              for (let key in err?.response?.data?.message) {
                if (err?.response?.data?.message?.hasOwnProperty(key)) {
                  error = err?.response?.data?.message[key];
                  break;
                }
              }
            }
            alert(error);
          }
          setDisableBtn(false);
        });
    } else {
      if(order?.rocketBoxOrderCreatedResp?.order_id){
        axios.post(process.env.REACT_APP_PATH_BULK+'/products/shipBulkOrderDirectly',{
          orderId:orderId
        }).then((res)=>{
          if(res.data.success){
            alert(res.data?.message||'Success')
            dataLoad();
          }else{
            alert(res.data?.message||'Someting went wrong')
            setDisableBtn(false);
          }
        }).catch(error=>{
          alert('Server error')
          setDisableBtn(false);
        })
      }else{
        setShippingModeModal(true);
        setOrderIdClick(orderId);
      }
    }
  };

  function CollapesRow({ order, index }) {
    const [open, setOpen] = React.useState(false);
    const [selectOrganizations, setSelectOrganization] = useState(
      order?.organization
    );
    const [numberOfProducts, setNumberOfProducts] = useState(0);
    const [allProductQnt, setAllProductQnt] = useState([]);
    const [buttonDis, setButtonDis] = useState(false);
    const [orignalProducts, setOrignalProduct] = useState(
      order?.products || []
    );
    const [file, setFile] = useState({});
    const [fileUploadDis, setFileUploadDis] = useState(true);

    const [amountOfOrderBreak, setAmountOfOrderBreak] = useState(190000);
    const [breakProducts, setBreakProducts] = useState([]);
    const [showProducts, setShowProducts] = useState(
      [...order?.products] || []
    );

    const breakProductOrderWise = () => {
      let temp = [...orignalProducts];
      temp.forEach((pro) => {
        let num = new Array(numOrder.length).fill(0);
        pro[`quantity${numOrder.length + 1}`] =
          numOrder.length == 0
            ? pro.quantity
            : pro.quantity -
            num
              .map((item, index) => pro[`quantity${index + 1}`] || 0)
              .reduce((acc, item) => (acc += item), 0);
      });
      setOrignalProduct(temp);
    };

    const addOrder = () => {
      let temp = numOrder;
      if (temp.length == 0) {
        setNumOfOrders([1]);
      } else {
        setNumOfOrders((pre) => [...pre, pre[pre.length - 1] + 1]);
      }
      // breakProductOrderWise();
    };

    // break order

    function gcd(a, b) {
      console.log("a", a, b);
      if (b === 0) {
        return a;
      }
      return gcd(b, a % b);
    }

    const breakOrder = () => {
      let orders = [];
      let maxLimit = amountOfOrderBreak;
      let pro = JSON.parse(JSON.stringify(order?.products));

      // let temprooo = order.products.map((p)=>({name:p.name,quantity:p.quantity,caseSize:p.caseSize,brandId:p.brandId,price:p.price}))
      // console.log('temp',temprooo)

      // Filter brandId 5 products and non-brandId 5 products from the beginning
      let keyWestProducts = pro.filter((p) =>
        ["6539e5f4ccd18dd0dbc4dc79", "65447bd2c93023787fedfa7c"].includes(
          p.brandId
        )
      );
      let otherProducts = pro.filter(
        (p) =>
          !["6539e5f4ccd18dd0dbc4dc79", "65447bd2c93023787fedfa7c"].includes(
            p.brandId
          )
      );

      let product1Id = "65b8e061fde3e7301d0c45ea";
      let product2Id = "6618c1b84118b3cdcc681ad0";
      let product3Id = "65c05ec4dc8f05a1e1c37474"; // Free product

      let specialProductList = otherProducts.filter((item) =>
        [product1Id, product2Id].includes(item.productId)
      );

      let freeProduct = otherProducts.find((p) => p.productId === product3Id);
      // let otherNonSpecialProducts = otherProducts.filter(
      //   (p) => ![product1Id, product2Id, product3Id].includes(p.productId)
      // );

      // let totalSpecialProductValue = specialProductList.reduce(
      //   (acc, item) => acc + item.price * item.quantity,
      //   0
      // );

      let totalOtherProduct = otherProducts.reduce((acc, item) => {
        return acc + item.price * item.quantity;
      }, 0);
      let totalKeywestProduct = keyWestProducts.reduce((acc, item) => {
        return acc + item.price * item.quantity;
      }, 0);


      let percentageOfKeywest = 0.2;
      let percentageOfOtherProduct = 0.8;

      // Helper function to handle keywest brand products (can be any quantity)
      const addkeyWestProducts = (order, keyWestProducts, targetValue) => {
        let addedValue = 0;
        for (let product of keyWestProducts) {
          if (product.quantity <= 0) continue;
          if (addedValue >= targetValue) break;
          let availableValue = product.price * product.quantity;
          if (addedValue + availableValue <= targetValue) {
            order.push({ ...product });
            addedValue += availableValue;
            product.quantity = 0;
          } else {
            let qtyNeeded = Math.floor(
              (targetValue - addedValue) / product.price
            );
            if (qtyNeeded > 0 && qtyNeeded * product.price <= targetValue) {
              order.push({ ...product, quantity: qtyNeeded });
              product.quantity -= qtyNeeded;
              addedValue += qtyNeeded * product.price;
            }
          }
        }
      };
      // Function to add special products while staying under maxLimit
      // Function to add special products while staying under maxLimit
      const addSpecialProducts = (order, targetValue) => {
        let addedValue = 0;
        let totalProduct1Qty = 0;
        let totalProduct2Qty = 0;

        for (let product of specialProductList) {
          if (product.quantity <= 0) continue;
          if (addedValue >= targetValue) break;

          let availableValue = product.price * product.quantity;

          if (addedValue + availableValue <= targetValue) {
            order.push({ ...product });
            addedValue += availableValue;

            // Track quantities
            if (product.productId === product1Id)
              totalProduct1Qty += product.quantity;
            if (product.productId === product2Id)
              totalProduct2Qty += product.quantity;

            product.quantity = 0;
          } else {
            let qtyNeeded = Math.floor(
              (targetValue - addedValue) / product.price
            );
            if (qtyNeeded > 0) {
              order.push({ ...product, quantity: qtyNeeded });
              addedValue += qtyNeeded * product.price;

              // Track quantities
              if (product.productId === product1Id)
                totalProduct1Qty += qtyNeeded;
              if (product.productId === product2Id)
                totalProduct2Qty += qtyNeeded;

              product.quantity -= qtyNeeded;
            }
          }
        }

        // Add Free Product 3 if needed
        let totalFreeProductQty = totalProduct1Qty + totalProduct2Qty;
        if (totalFreeProductQty > 0 && freeProduct) {
          order.push({ ...freeProduct, quantity: totalFreeProductQty });
        }
      };

      // Main loop to split products into multiple orders
      while (
        otherProducts.some((p) => p.quantity > 0) ||
        keyWestProducts.some((p) => p.quantity > 0)
        //  ||
        // specialProductList.some((p) => p.quantity > 0)
      ) {
        let order = [];
        let orderTotal = 0;
        // console.log('runnn')
        // Add non-brandId 5 products (must respect case size)
        let keyWestProductsTotal = pro.filter((p) =>
          ["6539e5f4ccd18dd0dbc4dc79", "65447bd2c93023787fedfa7c"].includes(
            p.brandId
          )
        );
        let checkQntykewwest = keyWestProductsTotal.filter(
          (item) => item.quantity > 0
        );
        // let specialProducts = [
        //   "6618c1b84118b3cdcc681ad0",
        //   "65b8e061fde3e7301d0c45ea",
        //   "65c05ec4dc8f05a1e1c37474",
        // ];
        // let filterSpecialProducts = otherProducts.filter((item) =>
        //   specialProducts.includes(item.productId)
        // );
        // if (filterSpecialProducts.length > 0) {
        //   order.push(...filterSpecialProducts);
        //   otherProducts = otherProducts.filter(
        //     (p) => !specialProducts.includes(p.productId)
        //   );
        //   let sumOfSpecialPro  = filterSpecialProducts.reduce((acc,item)=>acc+(item?.subTotal||(item.mrp*item.quantity)),0)
        //   console.log('s----',sumOfSpecialPro)
        //   orderTotal+=sumOfSpecialPro
        // }

        // Add Special Products first
        // let maxSpecialProductValue = Math.min(
        //   totalSpecialProductValue,
        //   maxLimit
        // );
        // addSpecialProducts(order, maxSpecialProductValue);
        // orderTotal += order.reduce(
        //   (acc, item) => acc + item.price * item.quantity,
        //   0
        // );

        for (let product of otherProducts) {
          product.caseSize = product?.caseSize || product?.quantity;
          const { price, caseSize, quantity } = product;
          // product.caseSize = product?.caseSize||10000
          // console.log('caseSize',product.caseSize)
          if (product.quantity <= 0) continue;
          let maxOtherValue =
            checkQntykewwest.length > 0
              ? maxLimit * percentageOfOtherProduct
              : maxLimit;

          // Calculate the cost of a single case
          const caseCost = price * caseSize;

          console.log("maxOtherValue", maxOtherValue);
          // Calculate how many full cases can be purchased within the max limit
          const maxCasesByCost = Math.floor(
            (maxOtherValue - orderTotal) / caseCost
          );

          // Determine the maximum number of cases based on available quantity
          const maxCasesByQuantity = Math.floor(quantity / caseSize);
          const maxCaseSize =
            Math.min(maxCasesByCost, maxCasesByQuantity) * caseSize;
          let maxCaseQuantity = maxCaseSize;
          let productValue = maxCaseQuantity * product.price;
          if (
            orderTotal + productValue <= maxOtherValue &&
            Math.round(maxCaseQuantity) > 0
          ) {
            if (
              orderTotal + product.quantity * product.price <=
              maxOtherValue
            ) {
              order.push({
                ...product,
                quantity: Math.round(product.quantity),
              });
              orderTotal += product.quantity * product.price;
              product.quantity -= Math.round(product.quantity);
            } else {
              order.push({ ...product, quantity: Math.round(maxCaseQuantity) });
              orderTotal += productValue;
              product.quantity -= Math.round(maxCaseQuantity);
            }
          } else {
            let spaceLeft = maxOtherValue - orderTotal;
            let qtyToAdd = Math.floor(spaceLeft / product.price);
            let adjustedQty =
              product.quantity <= product.caseSize
                ? product.quantity
                : Math.floor(qtyToAdd / product.caseSize) * product.caseSize;
            if (
              adjustedQty > 0 &&
              spaceLeft > 0 &&
              spaceLeft >= product.quantity * product.price
            ) {
              order.push({ ...product, quantity: product.quantity });
              orderTotal += product.quantity * product.price;
              product.quantity -= product.quantity;
            } else {
              if (qtyToAdd && spaceLeft >= qtyToAdd * product.price) {
                order.push({ ...product, quantity: qtyToAdd });
                orderTotal += qtyToAdd * product.price;
                product.quantity -= qtyToAdd;
              }
            }
            continue;
          }
        }

        // Add keywest products to meet the 20% of the total order value
        let maxKeywestProductValue =
          order.length > 0
            ? orderTotal * percentageOfKeywest <
              maxLimit * (percentageOfKeywest - 0.05)
              ? maxLimit * percentageOfKeywest
              : orderTotal * percentageOfKeywest
            : maxLimit;
        if (keyWestProducts.some((p) => p.quantity > 0)) {
          addkeyWestProducts(order, keyWestProducts, maxKeywestProductValue);
        }
        // Ensure at least one keywest product is in the order
        if (
          !order.some((p) =>
            ["6539e5f4ccd18dd0dbc4dc79", "65447bd2c93023787fedfa7c"].includes(
              p.brandId
            )
          ) &&
          keyWestProducts.some((p) => p.quantity > 0)
        ) {
          let product = keyWestProducts.filter((p) => p.quantity > 0)[0];
          let qtyNeeded = Math.min(
            product.quantity,
            Math.ceil(maxKeywestProductValue / product.price)
          );
          if (
            qtyNeeded > 0 &&
            qtyNeeded * product.price <= maxKeywestProductValue - orderTotal
          ) {
            order.push({ ...product, quantity: qtyNeeded });
            product.quantity -= qtyNeeded;
            orderTotal += qtyNeeded * product.price;
            // break
          }
        }

        orders.push(order);
      }
      setShowProducts(order?.products);
      setBreakProducts(orders);
      console.log("proror", orders);
    };

    const handleChange = (e) => {
      const files = e.target.files;
      if (files && files[0]) {
        setFile(files[0]);
        setFileUploadDis(false);
      }
    };

    const breakOrderUsingExcel = () => {
      const reader = new FileReader();
      const rABS = !!reader.readAsBinaryString;
      reader.onload = (e) => {
        /* Parse data */
        const bstr = e.target.result;
        const wb = XLSX.read(bstr, {
          type: rABS ? "binary" : "array",
          bookVBA: true,
          cellDates: true,
        });
        /* Get first worksheet */
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        /* Convert array of arrays */
        const data = XLSX.utils.sheet_to_json(ws);
        /* Update state */
        console.log("daata", data);

        let orders = [];
        new Array(Object.keys(data[0]).length - 1)
          .fill(0)
          .forEach((newPro, index) => {
            let singleOrder = [];
            order.products.forEach((pro) => {
              data.forEach((proFromExcel) => {
                if (pro.productId == proFromExcel.productId) {
                  console.log("----");
                  singleOrder.push({
                    ...pro,
                    quantity: proFromExcel[`order${index + 1}`],
                  });
                }
              });
            });
            orders.push(singleOrder);
          });
        setBreakProducts(orders);
      };

      if (rABS) {
        reader.readAsBinaryString(file);
      } else {
        reader.readAsArrayBuffer(file);
      }
    };

    const removeOrder = (it) => {
      let remove = breakProducts.filter((item, index) => index != it);
      setBreakProducts(remove);
    };

    const addOrderInBreakProducts = () => {
      let temp = [...breakProducts];
      temp.push([]);
      setBreakProducts(temp);
    };
    const quantityChangeOfProduct = (product, childIndex, value) => {
      let temp = [...breakProducts];
      let childOrder = temp[childIndex];
      let findProduct = childOrder.findIndex(
        (p) => p.productId == product.productId
      );
      if (findProduct > -1) {
        childOrder[findProduct].quantity = +value;
      } else {
        childOrder.push({
          ...product,
          quantity: +value,
        });
      }
      setBreakProducts(temp);
    };

    const orderCreateApi = () => {
      setButtonDis(true);
      const newProductSplit = [...breakProducts];

      const filterData = newProductSplit.map((order) => {
        return order.filter((product) => product.quantity > 0);
      });

      axios
        .post(process.env.REACT_APP_PATH_BULK + "/sales/createAndSplitBulkOrders", {
          orders: filterData,
          mainOrderId: order?._id,
        })
        .then((res) => {
          console.log("res of create order", res.data);
          if (res.data.success) {
            dataLoad();
          } else {
            alert(res.data?.message || "Someting went wrong");
          }
          setButtonDis(false);
        })
        .catch((error) => {
          console.log("error of create list", error);
          alert("Someting went wrong");
          setButtonDis(false);
        });
    };

    const isDisable = (pro, num) => {
      let mainTotalQnt = 0;
      let breakOrderQnt = 0;

      orignalProducts.forEach((pro) => {
        mainTotalQnt += pro.quantity;
      });

      breakProducts.forEach((i) => {
        i.forEach((t) => {
          breakOrderQnt += t.quantity;
        });
      });

      if (mainTotalQnt == breakOrderQnt) {
        return false;
      } else return true;
    };
    const getTotalPaybel = (pro, num, buttonNum) => {
      let temp = [];
      let mrpAndDiscount = [];
      const totalPay = [];
      let sum = 0;

      pro.forEach((it) => {
        let temp2 = [];
        num.forEach((nu) => {
          temp2.push(it[`quantity${nu}`]);
        });
        temp.push(temp2);

        mrpAndDiscount.push({
          mrp: it?.mrp || it?.menuPrice,
          discount: it.discount,
        });
      });

      mrpAndDiscount.forEach((ite, index) => {
        let qnt = temp[index][buttonNum - 1];
        sum += (qnt * ite.mrp * (100 - ite.discount)) / 100;
      });
      return sum;
    };

    const getTotalPaybel2 = (product) => {
      // console.log('productproduct',product)
      let sum = product.reduce(
        (acc, item) => (acc += (item?.quantity || 0) * (item?.price || 0)),
        0
      );
      return Math.round(sum);
    };

    // const createPoOnZoho = (orderId) => {
    //   console.log("order id", orderId);
    //   ApiInstance.post('/products/createPurchaseOrderAtZoho',{
    //     orderId:orderId
    //   }
    //   ).then((res)=>{
    //     if(res.data.success){
    //       alert('Success')
    //       dataLoad()
    //     }
    //   }).catch((error)=>{
    //     alert('Someting went wrong')
    //   })
    // };

    return (
      <React.Fragment>
        <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
          <TableCell>
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => {
                setOpenTable({
                  index: index,
                  isOpen: !openTableIndex.isOpen,
                });
              }}
            >
              {openTableIndex.index == index && openTableIndex.isOpen ? (
                <KeyboardArrowUpIcon />
              ) : (
                <KeyboardArrowDownIcon />
              )}
            </IconButton>
          </TableCell>
          <TableCell>{order.numericOrderId}</TableCell>
          <TableCell>{order?.name}</TableCell>
          <TableCell>{order?.phoneNumber}</TableCell>
          <TableCell>{order?.agent?.name}</TableCell>
          <TableCell>
            {moment(order.createdAt).format("HH:mm A - DD/MM/YYYY")}
          </TableCell>
          <TableCell>{order?.seller?.gstNumber || "not found"}</TableCell>
          <TableCell>{order?.seller?.businessName || "not found"}</TableCell>
          <TableCell>{order?.totalPayableAmount}</TableCell>
          <TableCell>{order?.weight || ""}</TableCell>
          <TableCell>{order?.shippingSuggestion || ""}</TableCell>
          <TableCell>
            {["8374454823", "9719836187"].includes(crmPhoneNumner) ? (
              <Button
                variant="outlined"
                onClick={() => {
                  setOpenAddressModal(true);
                  setSelectedOrderId(order?._id);
                  setSelectAddress(order?.address);
                }}
              >
                Edit Address
              </Button>
            ) : (
              ""
            )}{" "}
          </TableCell>
          <TableCell>
            {tyoeOfObj[order?.orderType] && (
              <span style={{ backgroundColor: "#ffbd03", padding: "5px 10px" }}>
                {tyoeOfObj[order?.orderType] || ""}
              </span>
            )}
          </TableCell>
          <TableCell>
            {" "}
            <FormControl>
              <InputLabel id="demo-simple-select-label">
                Select Organization*
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                onChange={(v) => setSelectOrganization(v.target.value)}
                value={selectOrganizations}
                label="Select Organization*"
                disabled={order?.organization}
                displayEmpty
              >
                <MenuItem>Select Organization</MenuItem>
                <MenuItem value={1}>Emergent</MenuItem>
                <MenuItem value={2}>Flordia Beauty</MenuItem>
                <MenuItem value={3}>Crescent</MenuItem>
              </Select>{" "}
            </FormControl>
          </TableCell>
          {order?.totalPayableAmount > 10000 ||
            (order?.totalPayableAmount < 10001 &&
              ["9719836187", "8800970879", '9873804039', '8178277221'].includes(crmPhoneNumner)) ? (
            <>
              {order?.ucSalesOrderCreatedAt &&
                moment(order?.ucSalesOrderCreatedAt).add(1, "minutes") <=
                moment(new Date()) ? (
                <TableCell>
                  <Button
                    size="small"
                    disabled={disableBtn || order?.awbNumber||onlyReadAccess.includes(crmPhoneNumner)}
                    variant="outlined"
                    onClick={(e) => {
                      setShipmentPopup({
                        open: true,
                        orderId: order?._id,
                        orderName: "shiprocket",
                        type: "unicommerce",
                      });
                      setBulkOrderFromRocket(false);
                    }}
                  >
                    {order?.awbNumber ? "Already Shiped On Uc" : "Ship On Uc"}
                  </Button>
                </TableCell>
              ) : order?.ucDuplicateSaleOrderAt && !order?.ucSalesOrderCreatedAt ? (
                <TableCell>
                  <Button
                    size="small"
                    style={{ color: "#d32f2f", borderColor: "#d32f2f" }}
                    variant="outlined"
                    disabled={disableBtn || onlyReadAccess.includes(crmPhoneNumner)}
                    onClick={() => cancelUcAndChangeOrderId(order)}
                  >
                    Cancel On UC & Change Order Id
                  </Button>
                </TableCell>
              ) : (
                <TableCell>
                  <Button
                    size="small"
                    disabled={
                      disableBtn &&
                      order?.ucSalesOrderCreatedAt &&
                      moment(new Date()) <
                        moment(order?.ucSalesOrderCreatedAt).add(1, "minutes")||onlyReadAccess.includes(crmPhoneNumner)
                    }
                    variant="outlined"
                    onClick={(e) =>
                      createOrder(order?._id, 1, selectOrganizations)
                    }
                  >
                    {order?.ucSalesOrderCreatedAt &&
                      moment(new Date()) <
                      moment(order?.ucSalesOrderCreatedAt).add(1, "minutes")
                      ? `Wait ${Math.ceil(
                        moment
                          .duration(
                            moment(order?.ucSalesOrderCreatedAt)
                              .add(1, "minutes")
                              .diff(moment(new Date()))
                          )
                          .asMinutes()
                      )} min`
                      : "Create Order On UC"}
                  </Button>
                </TableCell>
              )}
            </>
          ) : (
            <TableCell />
          )}
          <TableCell>
            {order.awbNumber && order.orderInventoryUpdatedAtZoho == false && (
              <Grid style={{ marginTop: 10, marginBottom: 10 }}>
                <Button
                  onClick={() => createPoOnZoho(order._id, selectOrganizations)}
                  variant="contained"
                  style={{ width: 120 }}
                  disabled={
                    createPoDisable || onlyReadAccess.includes(crmPhoneNumner)
                  }
                >
                  Create PO
                </Button>
              </Grid>
            )}
            {(order.shipShopyOrderId || order.shipShopyResponse) && !order.awbNumber && (
              <Grid style={{ marginTop: 10, marginBottom: 10 }}>
                <Button
                  onClick={() => handleShipShopyAction(order)}
                  variant="contained"
                  style={{ width: 120 }}
                  disabled={
                    disableBtn || onlyReadAccess.includes(crmPhoneNumner)
                  }
                >
                  {order?.shipShopyResponse?.courierAssigned
                    ? "Fetch AWB"
                    : "Assign Courier"}
                </Button>
              </Grid>
            )}
            {order.status == 1 && (
              <Button
                variant="outlined"
                color="error"
                disabled={onlyReadAccess.includes(crmPhoneNumner)}
                onClick={() => {
                  setSelectOrderId(order?._id)
                  setIsRemarkModalOpen(true)
                }}
              >
                Cancel Order
              </Button>
            )}
          </TableCell>
          <TableCell>
            <div style={{ display: "flex", flexDirection: "row" }}>
              {[
                "8178277221",
                "9599412543",
                "9719836187",
                "8800970879",
                "9693813591",
                "9873804039",
                '9034223172',
                '7052950504',
                '8130902064'
              ].includes(crmPhoneNumner) ? (
                <>
                  {/* {console.log('order?.totalPayableAmount',order?.totalPayableAmount)} */}
                  {["9719836187", "9599412543", "8178277221", '9034223172', '7052950504', '8130902064'].includes(
                    crmPhoneNumner
                  ) && (
                      <div>
                        {/* {console.log('yesss',order?.totalPayableAmount,order)} */}
                        {order?.ucInvoiceIdsForBulkOrder &&
                          order?.ucInvoiceIdsForBulkOrder?.length > 0 ? (
                          <div style={{ display: "flex", flexDirection: "row" }}>
                            {/* {console.log('ucInvoiceIdsForBulkOrder',order?.ucInvoiceIdsForBulkOrder)} */}
                            <div>
                              <Grid style={{ marginRight: 10 }}>
                                <TextField
                                  value={amountOfOrderBreak}
                                  onChange={(event) =>
                                    setAmountOfOrderBreak(+event.target.value)
                                  }
                                  variant="outlined"
                                  label="Enter Amount / Order"
                                  style={{ marginBottom: 10 }}
                                />
                                <Button
                                  onClick={breakOrder}
                                  variant="contained"
                                  style={{ width: 120 }}
                                >
                                  Split Order
                                </Button>
                              </Grid>
                              <Grid style={{ marginTop: 10 }}>
                                <LoadingButton
                                  onClick={orderCreateApi}
                                  variant="contained"
                                  style={{ width: 120 }}
                                  disabled={buttonDis || isDisable()}
                                  loading={buttonDis}
                                  loadingIndicator="Loading..."
                                >
                                  order Create
                                </LoadingButton>
                              </Grid>
                            </div>
                            <div style={{ marginLeft: 10 }}>
                              <input
                                type="file"
                                className="form-control"
                                id="file"
                                accept={SheetJSFT}
                                onChange={handleChange}
                              />
                              <LoadingButton
                                onClick={breakOrderUsingExcel}
                                variant="contained"
                                loadingIndicator="Uploading..."
                                style={{
                                  padding: "5px 10px",
                                  width: 120,
                                  marginTop: 5,
                                }}
                                disabled={fileUploadDis}
                              >
                                Upload
                              </LoadingButton>
                            </div>
                          </div>
                        ) : null}
                      </div>
                    )}
                  {/* ) : */}

                  {/* ( */}
                  <>
                    {[
                      "8178277221",
                      "8800970879",
                      "9719836187",
                      "9693813591",
                      "9873804039",
                      '9034223172'
                    ].includes(crmPhoneNumner) &&
                      !order?.ucSalesOrderCreatedAt ? (
                      <Grid>
                        <LoadingButton
                          variant="contained"
                          loading={loadingOfShiprocketOrder}
                          loadingIndicator="Loading..."
                          onClick={() =>
                            createOrderOnShiprocket(
                              orignalProducts,
                              order.sellerId,
                              order.agentId,
                              order.paymentMethod,
                              order.address,
                              order._id,
                              order?.createdAt
                            )
                          }
                        >
                          Ship By ShipRocket
                        </LoadingButton>
                      </Grid>
                    ) : null}
                  </>
                  {/* )} */}
                  {/* {["8178277221", "8800970879", "9719836187"].includes(
                    crmPhoneNumner
                  ) && !order?.ucSalesOrderCreatedAt ? (
                    <Grid>
                      <LoadingButton
                        variant="contained"
                        loading={loadingOfShiprocketOrder}
                        loadingIndicator="Loading..."
                        onClick={() =>
                          createOrderOnShiprocket(
                            orignalProducts,
                            order.sellerId,
                            order.agentId,
                            order.paymentMethod,
                            order.address,
                            order._id,
                            order?.createdAt
                          )
                        }
                      >
                        Ship By ShipRocket
                      </LoadingButton>
                    </Grid>
                  ) : null} */}
                </>
              ) : null}
            </div>
          </TableCell>
          <TableCell>
            <Link
              to={`/bulkorderdetails/${order._id}`}
              style={{
                color: order.paymentMethod == 1 ? "#000" : "green",
              }}
              target="_blank"
            >
              Details
            </Link>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell
            style={{ paddingBottom: 0, paddingTop: 0, overflowX: "scroll" }}
            colSpan={11}
          >
            <Collapse
              in={openTableIndex.isOpen && index == openTableIndex.index}
              timeout="auto"
              unmountOnExit
            >
              <Box sx={{ margin: 1, width: "100%", overflowX: "scroll" }}>
                <Table
                  aria-label="purchases"
                  style={{ overflowX: "scroll", maxWidth: "100vw" }}
                >
                  <TableHead>
                    <TableRow>
                      <TableCell style={{ minWidth: 250 }}>Name</TableCell>
                      <TableCell>Mrp</TableCell>
                      <TableCell>Total Quantity</TableCell>
                      <TableCell>Case Size</TableCell>
                      {breakProducts.map((item, index) => (
                        <TableCell
                          style={{
                            minWidth: 150,
                            flexShrink: 0,
                            flexGrow: 0,
                            overflow: "visible",
                          }}
                        >
                          <div style={{ position: "relative" }}>
                            Order {index + 1}
                            {breakProducts.length - 1 == index && (
                              <div
                                style={{
                                  position: "absolute",
                                  top: 0,
                                  right: 5,
                                  cursor: "pointer",
                                  zIndex: 200,
                                  display: "flex",
                                  flexDirection: "row",
                                  alignItems: "center",
                                }}
                              >
                                <div
                                  variant="outlined"
                                  style={{
                                    border: "1px solid red",
                                    fontSize: 18,
                                    color: "red",
                                    marginRight: 5,
                                    padding: "2px 6px",
                                  }}
                                  onClick={() => removeOrder(index)}
                                >
                                  x{" "}
                                </div>
                                <div
                                  variant="contained"
                                  onClick={() => addOrderInBreakProducts()}
                                  style={{
                                    border: "1px solid green",
                                    fontSize: 18,
                                    color: "green",
                                    padding: "2px 6px",
                                  }}
                                >
                                  +
                                </div>
                              </div>
                            )}
                          </div>
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {showProducts
                      .slice(
                        numberOfProducts * limitOfProducts,
                        numberOfProducts * limitOfProducts + limitOfProducts
                      )
                      .map((pro, parentIndex) => (
                        <TableRow>
                          <TableCell
                            style={{
                              minWidth: 250,
                              flexGrow: 0,
                              flexShrink: 0,
                            }}
                          >
                            {pro.name}
                          </TableCell>
                          <TableCell>{pro.mrp}</TableCell>
                          <TableCell>{pro.quantity}</TableCell>
                          <TableCell>{pro?.caseSize || 0}</TableCell>
                          {breakProducts &&
                            breakProducts.length > 0 &&
                            breakProducts.map((item, index) => (
                              <TableCell style={{ width: 100 }}>
                                <TextField
                                  type="number"
                                  value={
                                    item.filter(
                                      (p) => p.productId == pro.productId
                                    )[0]?.quantity || 0
                                  }
                                  onChange={(t) =>
                                    quantityChangeOfProduct(
                                      pro,
                                      index,
                                      t.target.value,
                                      parentIndex
                                    )
                                  }
                                  style={{ width: 100 }}
                                />
                              </TableCell>
                            ))}
                        </TableRow>
                      ))}
                    <TableRow>
                      <TableCell colSpan={1}>Total Payable</TableCell>

                      <TableCell colSpan={1}></TableCell>
                      <TableCell>
                        {numericCommaSeparation(order?.totalPayableAmount)}
                      </TableCell>
                      <TableCell colSpan={1}></TableCell>
                      {breakProducts.map((item) => (
                        <TableCell>
                          {/* <Button
                            variant="contained"
                            disabled={isDisable(
                              orignalProducts,
                              numOrder
                            )}
                          >
                            Create
                          </Button> */}
                          <p>{numericCommaSeparation(getTotalPaybel2(item))}</p>
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableBody>
                  {orignalProducts.length > limitOfProducts && (
                    <TablePagination
                      component="div"
                      rowsPerPageOptions={[limitOfProducts]}
                      count={orignalProducts.length}
                      page={numberOfProducts}
                      rowsPerPage={limitOfProducts}
                      onPageChange={(v, newValue) => {
                        setNumberOfProducts(newValue);
                      }}
                      style={{ width: 300 }}
                    />
                  )}
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }
  function CollapesRowForChildProduct({ order, index }) {
    const [open, setOpen] = React.useState(false);
    const [selectOrganizations, setSelectOrganization] = useState(
      order?.organization
    );

    return (
      <React.Fragment>
        <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
          <TableCell>
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => {
                setOpenTable({
                  index: index,
                  isOpen: !openTableIndex.isOpen,
                });
              }}
            >
              {openTableIndex.index == index && openTableIndex.isOpen ? (
                <KeyboardArrowUpIcon />
              ) : (
                <KeyboardArrowDownIcon />
              )}
            </IconButton>
          </TableCell>
          <TableCell>{order.numericOrderId}</TableCell>
          <TableCell>{order?.name}</TableCell>
          <TableCell>{order?.phoneNumber}</TableCell>
          <TableCell>{order?.agent?.name}</TableCell>
          <TableCell>
            {moment(order.createdAt).format("HH:mm A - DD/MM/YYYY")}
          </TableCell>

          <TableCell>{order?.seller?.gstNumber || "not found"}</TableCell>
          <TableCell>{order?.seller?.businessName || "not found"}</TableCell>
          <TableCell>{order?.totalPayableAmount}</TableCell>
          <TableCell>{order?.weight || ""}</TableCell>
          <TableCell>{order?.shippingSuggestion || ""}</TableCell>
          <TableCell></TableCell>
          <TableCell>
            {tyoeOfObj[order?.orderType] && (
              <span style={{ backgroundColor: "#ffbd03", padding: "5px 10px" }}>
                {tyoeOfObj[order?.orderType] || ""}
              </span>
            )}
          </TableCell>
          <TableCell>
            {" "}
            <FormControl>
              <InputLabel id="demo-simple-select-label">
                Select Organization*
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                onChange={(v) => setSelectOrganization(v.target.value)}
                value={selectOrganizations}
                label="Select Organization*"
                disabled={order?.organization}
                displayEmpty
              >
                <MenuItem>Select Organization</MenuItem>
                <MenuItem value={1}>Emergent</MenuItem>
                <MenuItem value={2}>Flordia Beauty</MenuItem>
                <MenuItem value={3}>Crescent</MenuItem>
              </Select>{" "}
            </FormControl>
          </TableCell>
          {/* <TableCell> */}
          {order?.totalPayableAmount > 10000 ||
            (order?.totalPayableAmount < 10001 &&
              [
                "9873804039",
                "9719836187",
                "8969708515",
                "8800970879",
                "9599412543",
                '8178277221',
                '8130902064'
              ].includes(crmPhoneNumner)) ? (
            <>
              <>
                {order?.ucSalesOrderCreatedAt &&
                  moment(order?.ucSalesOrderCreatedAt).add(1, "minutes") <=
                  moment(new Date()) ? (
                  <TableCell>
                    <Button
                      size="small"
                      disabled={disableBtn || order?.awbNumber || onlyReadAccess.includes(crmPhoneNumner)}
                      variant="outlined"
                      onClick={(e) => {
                        setShipmentPopup({
                          open: true,
                          orderId: order?._id,
                          orderName: "shiprocket",
                          type: "unicommerce",
                          organizations: selectOrganizations,
                          title: "UC",
                        });
                        setBulkOrderFromRocket(false);
                      }}
                    >
                      {order?.awbNumber ? "Already shiped On Uc" : "Ship On Uc"}
                    </Button>
                  </TableCell>
                ) : order?.ucDuplicateSaleOrderAt && !order?.ucSalesOrderCreatedAt ? (
                  <TableCell>
                    <Button
                      size="small"
                      style={{ color: "#d32f2f", borderColor: "#d32f2f" }}
                      variant="outlined"
                      disabled={disableBtn || onlyReadAccess.includes(crmPhoneNumner)}
                      onClick={() => cancelUcAndChangeOrderId(order)}
                    >
                      Cancel On UC & Change Order Id
                    </Button>
                  </TableCell>
                ) : (
                  <TableCell>
                    <Button
                      size="small"
                      disabled={
                        disableBtn &&
                        order?.ucSalesOrderCreatedAt &&
                        moment(new Date()) <
                        moment(order?.ucSalesOrderCreatedAt).add(1, "minutes") || onlyReadAccess.includes(crmPhoneNumner)
                      }
                      variant="outlined"
                      onClick={(e) =>
                        createOrder(order?._id, 1, selectOrganizations)
                      }
                    >
                      {order?.ucSalesOrderCreatedAt &&
                        moment(new Date()) <
                        moment(order?.ucSalesOrderCreatedAt).add(1, "minutes")
                        ? `Wait ${Math.ceil(
                          moment
                            .duration(
                              moment(order?.ucSalesOrderCreatedAt)
                                .add(1, "minutes")
                                .diff(moment(new Date()))
                            )
                            .asMinutes()
                        )} min`
                        : "Create Order On Uc"}
                    </Button>
                  </TableCell>
                )}
              </>
            </>
          ) : (
            <TableCell />
          )}
          {/* </TableCell> */}

          <TableCell>
            {order.awbNumber && order.orderInventoryUpdatedAtZoho == false && (
              <Grid style={{ marginTop: 10 }}>
                <Button
                  onClick={() => createPoOnZoho(order._id, selectOrganizations)}
                  variant="contained"
                  style={{ width: 120 }}
                  disabled={onlyReadAccess.includes(crmPhoneNumner)}
                >
                  Create PO
                </Button>
              </Grid>
            )}
          </TableCell>
          <TableCell />
          <TableCell>
            <Link
              to={`/bulkorderdetails/${order._id}`}
              style={{
                color: order.paymentMethod == 1 ? "#000" : "green",
              }}
              target="_blank"
            >
              Details
            </Link>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={12}>
            <Collapse
              in={openTableIndex.isOpen && index == openTableIndex.index}
              timeout="auto"
              unmountOnExit
            >
              <Box sx={{ margin: 1 }}>
                <Table size="small" aria-label="purchases">
                  <TableHead>
                    <TableRow>
                      <TableCell>Order Id</TableCell>
                      <TableCell>Discount</TableCell>
                      <TableCell>Total Payable</TableCell>
                      <TableCell>Zoho Invoice No.</TableCell>
                      <TableCell>Eway Bill Number</TableCell>
                      <TableCell>Details</TableCell>
                      <TableCell>Action</TableCell>
                      <TableCell>CN Discount</TableCell>
                      <TableCell>Info</TableCell>
                      <TableCell>
                        {accessButtonForCancelOrder.includes(crmPhoneNumner) &&
                          "Cancel Order"}
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {order.childOrders.map((childOrder, idx) => (
                      <TableRow key={childOrder.createdAt}>
                        <TableCell component="th" scope="row">
                          {childOrder.numericOrderId}
                        </TableCell>
                        <TableCell>
                          {childOrder?.discountBreakupInfo1.reduce(
                            (acc, dis) => {
                              const value = Object.values(dis)[0]; // Extracting the value from each object
                              return acc + Math.round(value);
                            },
                            0
                          )}
                        </TableCell>
                        <TableCell>{childOrder.totalPayableAmount}</TableCell>
                        <TableCell>
                          {childOrder.zohoInvoice?.zohoInvoiceNumber || ""}
                        </TableCell>
                        <TableCell>
                          {childOrder?.ewayBillNumber || ""}
                        </TableCell>

                        <TableCell>
                          <Link
                            to={`/bulkorderdetails/${childOrder._id}`}
                            style={{
                              color:
                                childOrder.paymentMethod == 1
                                  ? "#000"
                                  : "green",
                            }}
                            target="_blank"
                          >
                            Details
                          </Link>
                        </TableCell>

                        <TableCell
                          style={{
                            minWidth: 220,
                            flexDirection: "row",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          {childOrder?.status == 1 &&
                          order.awbNumber &&
                          !childOrder?.awbNumber ? (
                            <>
                              {childOrder.shipShopyOrderId || childOrder.shipShopyResponse ? (
                                <Button
                                  size="small"
                                  disabled={
                                    disableBtn ||
                                    onlyReadAccess.includes(crmPhoneNumner)
                                  }
                                  variant="outlined"
                                  onClick={(e) =>
                                    handleShipShopyAction(childOrder)
                                  }
                                >
                                  {childOrder?.shipShopyResponse
                                    ?.courierAssigned
                                    ? "Fetch AWB"
                                    : "Assign Courier"}
                                </Button>
                              ) : (
                                <>
                                  <Button
                                    size="small"
                                    disabled={
                                      disableBtn ||
                                      loading ||
                                      onlyReadAccess.includes(crmPhoneNumner)
                                    }
                                    variant="outlined"
                                    onClick={(e) => {
                                      setIsZohoInvoice(
                                        childOrder.zohoInvoice
                                          ?.zohoInvoiceNumber || null
                                      );
                                      handelShippingMode(
                                        childOrder?._id,
                                        childOrder.zohoInvoice
                                          ?.zohoInvoiceNumber
                                          ? false
                                          : true,
                                        childOrder
                                      );
                                    }}
                                  >
                                    {childOrder.zohoInvoice?.zohoInvoiceNumber
                                      ? "Ship Order"
                                      : "Create Zoho Invoice"}
                                  </Button>

                                  {childOrder?.zohoInvoice?.total >= 50000 &&
                                    childOrder?.ewayBillNumber == undefined && (
                                      <Button
                                        size="small"
                                        disabled={
                                          disableBtn ||
                                          loading ||
                                          onlyReadAccess.includes(
                                            crmPhoneNumner
                                          )
                                        }
                                        style={{ marginLeft: 10 }}
                                        variant="outlined"
                                        onClick={(e) => {
                                          setEwayBillModal({
                                            orderId: childOrder._id,
                                            modal: true,
                                          });
                                        }}
                                      >
                                        Update Eway Bill
                                      </Button>
                                    )}
                                </>
                              )}
                            </>
                          ) : null}
                        </TableCell>
                        <TableCell>
                          {/* {!childOrder?.awbNumber && (
                            <Grid>
                              <Button
                                variant="contained"
                                onClick={() => {
                                  setCnDiscountModal({
                                    modal: true,
                                    orderId: childOrder?._id,
                                  });
                                  setCnDiscount(
                                    childOrder?.cnDiscountPercentage || 10
                                  );
                                }}
                              >
                                Update CN Discount
                              </Button>
                            </Grid>
                          )} */}
                        </TableCell>

                        <TableCell>
                          {!childOrder?.awbNumber == 1 &&
                            childOrder?.rocketBoxShipError &&
                            childOrder?.rocketBoxShipError?.non_field_errors &&
                            childOrder?.rocketBoxShipError?.non_field_errors[0]
                            ? childOrder?.rocketBoxShipError
                              ?.non_field_errors[0]
                            : ""}
                        </TableCell>
                        <TableCell>
                          {accessButtonForCancelOrder.includes(
                            crmPhoneNumner
                          ) &&
                            childOrder.status == 1 &&
                            !childOrder?.zohoInvoice?.zohoInvoiceNumber && (
                              <Button
                                variant="outlined"
                                color="error"
                                disabled={onlyReadAccess.includes(crmPhoneNumner)}
                                onClick={() => {
                                  setSelectOrderId(childOrder?._id)
                                  setIsRemarkModalOpen(true)
                                  // CancelChildOrder(childOrder?._id)
                                }
                                }
                              >
                                Cancel Order
                              </Button>
                            )}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }

  return (
    <>
      <MainCard content={false} title="Bulk Orders">
        <Grid container spacing={2} alignItems={"center"}>
          <Grid xs={12} sm={12} md={6} lg={3} item>
            <TextField
              id="datetime-local"
              label="Start Date"
              type="date"
              defaultValue={date.startDate}
              className={classes.textField}
              InputLabelProps={{
                shrink: true,
              }}
              style={{
                width: "100%",
              }}
              onChange={(e) =>
                setDate({
                  ...date,
                  startDate: e.target.value,
                })
              }
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={3}>
            <TextField
              id="datetime-local"
              label="End Date"
              type="date"
              defaultValue={date.endDate}
              className={classes.textField}
              InputLabelProps={{
                shrink: true,
              }}
              style={{
                width: "100%",
              }}
              onChange={(e) =>
                setDate({
                  ...date,
                  endDate: e.target.value,
                })
              }
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={3}>
            <TextField
              label="Order Id"
              defaultValue={parentBulkNumericOrderId}
              fullWidth
              onChange={(e) => setParentBulkNumericOrderId(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={3}>
            <LoadingButton
              variant="contained"
              style={{
                width: "100%",
              }}
              loadingIndicator="loading..."
              onClick={() => dataLoad()}
              loading={loading}
            >
              Submit
            </LoadingButton>
          </Grid>
        </Grid>
        <CardContent>
          <Grid
            container
            justifyContent="space-between"
            alignItems="center"
            spacing={1}
          >
            <Grid row container alignItems="center">
              <Grid item xs={12} lg={4} ml={2}>
                <Button
                  onClick={() => dataLoad(page, rowsPerPage)}
                  variant="contained"
                  style={{ marginLeft: 10 }}
                  disabled={onlyReadAccess.includes(crmPhoneNumner)}
                >
                  Refresh
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </CardContent>

        <TableContainer style={{ overflowX: "auto", width: "100%" }}>
          <Table aria-label="collapsible table">
            <TableHead>
              <TableRow>
                <TableCell
                  sx={{ fontWeight: "bold", padding: "16px" }}
                ></TableCell>
                <TableCell sx={{ fontWeight: "bold", minWidth: 100 }}>
                  Order Id
                </TableCell>
                <TableCell sx={{ fontWeight: "bold", minWidth: 150 }}>
                  Name
                </TableCell>
                <TableCell sx={{ fontWeight: "bold", minWidth: 150 }}>
                  Phone Number
                </TableCell>
                <TableCell sx={{ fontWeight: "bold", minWidth: 200 }}>
                  Agent Name
                </TableCell>
                <TableCell sx={{ fontWeight: "bold", minWidth: 180 }}>
                  Order Date
                </TableCell>
                <TableCell sx={{ fontWeight: "bold", minWidth: 130 }}>
                  GST Number
                </TableCell>
                <TableCell sx={{ fontWeight: "bold", minWidth: 200 }}>
                  Business Name
                </TableCell>
                <TableCell sx={{ fontWeight: "bold", minWidth: 120 }}>
                  Total Payable
                </TableCell>
                <TableCell sx={{ fontWeight: "bold", minWidth: 120 }}>
                  Weight
                </TableCell>
                <TableCell sx={{ fontWeight: "bold", minWidth: 180 }}>
                  Shipping Suggestion
                </TableCell>
                <TableCell sx={{ fontWeight: "bold", minWidth: 180 }}>
                  Update Address
                </TableCell>
                <TableCell sx={{ fontWeight: "bold", minWidth: 120 }}>
                  Order Type
                </TableCell>
                <TableCell sx={{ fontWeight: "bold", minWidth: 200 }}>
                  Select Organizations
                </TableCell>
                <TableCell
                  colSpan={2}
                  sx={{ fontWeight: "bold", minWidth: 200 }}
                  align="center"
                >
                  Action
                </TableCell>{" "}
                <TableCell></TableCell>
                <TableCell sx={{ fontWeight: "bold", minWidth: 150 }}>
                  Details
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {orderdata &&
                orderdata.length > 0 &&
                orderdata.map((order, index) =>
                  order?.childOrders.length > 0 ? (
                    <CollapesRowForChildProduct order={order} index={index} />
                  ) : (
                    <CollapesRow order={order} index={index} />
                  )
                )}
            </TableBody>
          </Table>
        </TableContainer>
        {/* table pagination */}
        <TablePagination
          rowsPerPageOptions={[25, 100, 200]}
          component="div"
          count={totalpage}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </MainCard>
      <Ordershippopup
        openShipmentPopup={openShipmentPopup}
        setShipmentPopup={setShipmentPopup}
        bulkOrder={true}
        bulkOrderFromRocket={bulkOrderFromRocket}
        isrocketOrPorter={openShipmentPopup.isrocketOrPorter}
      />
      <AlertModal
        visible={shippingModeModal}
        orderId={orderIdClick}
        onClose={() => {
          setShippingModeModal(false);
          setIsZohoInvoice(null);
        }}
        isZohoInvoce={isZohoInvoce}
        okPress={() => {
          setTimeout(() => {
            setShipmentPopup({
              open: true,
              orderId: orderIdClick,
              orderName: "rocketBox",
              type: "unicommerce",
              isrocketOrPorter: true,
            });
            setBulkOrderFromRocket(true);
          }, 200);
          setShippingModeModal(false);
          setIsZohoInvoice(null);
        }}
      />
      <Dialog
        open={ewayBillModal.modal}
        fullWidth
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogTitle id="alert-dialog-title">
            <Grid container>
              <Grid item lg={6}>
                <Typography variant="h3">Update Eway Bill Number</Typography>
              </Grid>
              <Grid item lg={6} justifyContent={"flex-end"} display={"flex"}>
                <Button
                  variant="outlined"
                  onClick={() =>
                    setEwayBillModal({
                      modal: false,
                      orderId: "",
                    })
                  }
                >
                  Close
                </Button>
              </Grid>
            </Grid>
          </DialogTitle>
          <Grid container>
            <Grid item lg={12}>
              <Divider />
            </Grid>
          </Grid>
          <Grid container>
            <Grid item lg={8} md={8} sm={12}>
              <DialogContentText id="alert-dialog-description">
                <TextField
                  type="text"
                  name="numofbox"
                  value={ewayBillNumber}
                  onChange={(e) => setEwayBillNumber(e.target.value)}
                  placeholder="Enter Eway Bill Number"
                  fullWidth
                  required
                />
              </DialogContentText>
            </Grid>
            <Grid item lg={4} md={4} sm={12}>
              <DialogActions>
                <Button
                  color="primary"
                  variant="contained"
                  onClick={() => updateEwayBillNumber(ewayBillNumber)}
                  disabled={onlyReadAccess.includes(crmPhoneNumner)}
                >
                  Update
                </Button>
              </DialogActions>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
      <Dialog
        open={cnDiscountModal.modal}
        fullWidth
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogTitle id="alert-dialog-title">
            <Grid container>
              <Grid item lg={6}>
                <Typography variant="h3">Update CN Discount</Typography>
              </Grid>
              <Grid item lg={6} justifyContent={"flex-end"} display={"flex"}>
                <Button
                  variant="outlined"
                  onClick={() =>
                    setCnDiscountModal({
                      modal: false,
                      orderId: "",
                    })
                  }
                  disabled={onlyReadAccess.includes(crmPhoneNumner)}
                >
                  Close
                </Button>
              </Grid>
            </Grid>
          </DialogTitle>
          <Grid container>
            <Grid item lg={12}>
              <Divider />
            </Grid>
          </Grid>
          <Grid container>
            <Grid item lg={8} md={8} sm={12}>
              <DialogContentText id="alert-dialog-description">
                <TextField
                  type="text"
                  name="numofbox"
                  value={cnDiscount}
                  onChange={(e) => setCnDiscount(e.target.value)}
                  placeholder="Enter Cn Discount"
                  fullWidth
                  required
                />
              </DialogContentText>
            </Grid>
            <Grid item lg={4} md={4} sm={12}>
              <DialogActions>
                <Button
                  color="primary"
                  variant="contained"
                  onClick={() => updateCnDiscount(ewayBillNumber)}
                  disabled={onlyReadAccess.includes(crmPhoneNumner)}
                >
                  Update
                </Button>
              </DialogActions>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>

      <EditAddressInOrderModal
        open={openAddressModal}
        handleClose={() => {
          setOpenAddressModal(false);
          setSelectedOrderId(null);
          setSelectAddress({});
        }}
        oldAddress={selectedAddress}
        selectedOrderId={selectedOrderId}
        dataLoad={dataLoad}
      />
      <OrderCancelRemarkModal
        open={isRemarkModalOpen}
        onSubmit={CancelChildOrder}
        onClose={() => {
          setSelectOrderId(null)
          setIsRemarkModalOpen(false)
        }}

      />

      <Dialog
        open={shipShopyModal.open}
        fullWidth
        aria-labelledby="shipshopy-dialog-title"
      >
        <DialogTitle id="shipshopy-dialog-title">
          Select Courier {shipShopyModal.weight && `(Weight: ${shipShopyModal.weight} KG)`}
        </DialogTitle>
        <DialogContent>
          {shipShopyModal.loading && shipShopyModal.couriers.length === 0 ? (
            <Typography>Loading couriers...</Typography>
          ) : (
            <FormControl fullWidth style={{ marginTop: 15 }}>
              <InputLabel id="courier-select-label">Select Courier</InputLabel>
              <Select
                labelId="courier-select-label"
                value={shipShopyModal.selectedCourierId}
                onChange={(e) =>
                  setShipShopyModal({
                    ...shipShopyModal,
                    selectedCourierId: e.target.value,
                  })
                }
              >
                {shipShopyModal.couriers.map((c) => (
                  <MenuItem key={c.id} value={c.id}>
                    {c.name} - Charges: ₹{c.total_charges} {c.estimated_delivery ? `- Est. Delivery: ${c.estimated_delivery}` : ""}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() =>
              setShipShopyModal({
                open: false,
                orderId: null,
                couriers: [],
                loading: false,
                selectedCourierId: "",
                weight: "",
              })
            }
          >
            Cancel
          </Button>
          <LoadingButton
            color="primary"
            variant="contained"
            onClick={submitShipShopyCourier}
            loading={shipShopyModal.loading && shipShopyModal.couriers.length > 0}
            disabled={!shipShopyModal.selectedCourierId}
          >
            Submit
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </>
  );
}
